import 'react-app-polyfill/ie9';
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React from 'react';
import ReactDOM from 'react-dom';
import { AuthenticationContext, adalFetch, runWithAdal } from 'react-adal';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';

const adalKey = '209290fb-0e88-470d-b4b4-1824f1053816';

const adalConfig = {
  tenant: '',
  clientId: adalKey,
  endpoints: {
    api: 'https://graph.microsoft.com',
  },
  cacheLocation: 'localStorage',
};

const authContext = new AuthenticationContext(adalConfig);

const adalApiFetch = (fetch, url, options) =>
  adalFetch(authContext, adalConfig.endpoints.api, fetch, url, options);

//const DO_NOT_LOGIN = window.location.hostname === 'localhost' || window.location.pathname.includes('testing');
const DO_NOT_LOGIN = true;

runWithAdal(authContext, () => {
  ReactDOM.render(<App/>, document.getElementById('root'));
}, DO_NOT_LOGIN);

export { adalApiFetch, authContext }

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
